
import CustomModal from "../CustomModal";
import { useLocations } from "../../../hooks/useLocations";


const AddPlanModal = ({
  isOpen,
  onClose,
  planName,
  setPlanName,
  planDuration,
  setPlanDuration,
  planAmount,
  setPlanAmount,
  onSubmit,
  locationId,
  setLocationId,
}) => {
  const { locations, loading: loadingLocations } = useLocations(isOpen);

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Add Subscription Plan"
      className="add-admin-modal"
    >
      <div className="add-staff-head">
        <h2>Add Subscription Plan</h2>
      </div>
      <form onSubmit={onSubmit}>
        <div className="inner-form">
          <label>
            Name:{" "}
            <input
              type="text"
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
              required
              placeholder="Plan name"
            />
          </label>
          <br />
          <label>
            Duration:{" "}
            <input
              type="text"
              value={planDuration}
              onChange={(e) => setPlanDuration(e.target.value)}
              required
              placeholder="Duration in days"
            />
          </label>
          <br />
          <label>
            Amount:{" "}
            <input
              type="number"
              value={planAmount}
              onChange={(e) => setPlanAmount(e.target.value)}
              required
              placeholder="Amount in naira"
            />
          </label>
          <br />
          <label>
            Location:
            <select
              value={locationId || ''}
              onChange={e => setLocationId(e.target.value)}
              required
              disabled={loadingLocations}
              style={{ marginBottom: 12 }}
            >
              <option value="" disabled>
                {loadingLocations ? 'Loading locations...' : 'Select a location'}
              </option>
              {locations.map(loc => (
                <option key={loc.id} value={loc.id}>{loc.name}</option>
              ))}
            </select>
          </label>
        </div>
        <div className="modal-button">
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <input type="submit" value="Add Plan" />
        </div>
      </form>
    </CustomModal>
  );
};

export default AddPlanModal;
